<script lang="ts">
    import {oneWayDragging} from '../../../../media-viewer/actions/use.one-way-dragging';
    import {clampErpSidebarWidth} from '../constants';
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher<{ 'new-width': number }>();

    export let initialWidth: number;
    export let dragging = false;

    $: width = initialWidth;
    $: resizeWidth = width;
    $: saveNewSidebarWidth(resizeWidth);

    const handleDragStart = () => {
        dragging = true;
    }

    const handleDrag = (event: CustomEvent<number>) => {
        dragging = true;
        resizeWidth = clampErpSidebarWidth(width + event.detail);
    }

    const handleOnDragEnd = () => {
        dragging = false;
        width = clampErpSidebarWidth(resizeWidth);
    }

    function saveNewSidebarWidth(newWidth: number) {
        dispatch('new-width', newWidth);
    }
</script>

<div class="erp-sidebar-nav-resizer"
     role="separator"
     class:dragging={dragging}
     use:oneWayDragging={{orientation:'vertical'}}
     on:dragging-start={handleDragStart}
     on:dragging-progress={handleDrag}
     on:dragging-end={handleOnDragEnd}>
</div>

<style lang="less">
    .erp-sidebar-nav-resizer {
        cursor: col-resize;
        position: absolute;
        z-index: 1;
        transform: translateX(1px);
        right: 0;
        top: 0;
        height: 100%;
        width: 4px;
        background-color: transparent;
        border-right: 3px dashed transparent;
        transition: 0.2s ease-in-out border-color;

        &:hover, &.dragging {
            border-color: var(--accent-blue);
        }
    }
</style>